<template>
  <v-container fluid>
    <v-tabs v-model="tab">
      <v-tab>Category templates</v-tab>
      <v-tab>Account templates</v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item :transition="false">
        <templates-edit-categories />
      </v-tab-item>
      <v-tab-item :transition="false">
        <templates-edit-account-templates />
      </v-tab-item>
    </v-tabs-items>
  </v-container>
</template>

<script>
import TemplatesEditCategories from '../components/TemplatesEditCategories.vue'
import TemplatesEditAccountTemplates from '../components/TemplatesEditAccountTemplates.vue'

export default {
  name: 'Templates',
  components: { TemplatesEditCategories, TemplatesEditAccountTemplates },
  data: () => ({
    tab: null
  })
}
</script>
